import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Holiday e-Card </h1>

    <div className="video">
      <iframe 
        src="https://www.youtube.com/embed/O9ZBoZs9ENM"
        frameBorder="0" 
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen 
      />
    </div>

    <p>A paper cut-out style animation, to represent a digital version of a holiday <a href="https://www.facebook.com/watch/?v=337254713548471" target="_blank">greeting card</a>. Made
    using 3D layers in Adobe After Effects.</p>


    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)